<template>
  <div class="page">
    <div class="listContentLayout" id="listContentLayout">
      <div class="item" v-for="(item, index) in data" :key="index">
        <div class="line">
          <div class="no line1">序号：{{ index + 1 }}</div>
          <div class="no line2">
            <div class="row">
              姓名：
              <span>{{ item.userName }}</span>
            </div>
            <div class="row">
              状态：
              <span>{{ getStatus(item) }}</span>
            </div>
          </div>
          <div class="no line2">
            <div class="row">
              手机：
              <span>{{ item.userPhone }}</span>
            </div>
            <div class="row">
              价格：
              <span>￥{{ item.totalPrice }}</span>
            </div>
          </div>
          <div class="no line2">
            <div class="row">
              出团时间：
              <span>{{ moment(item.startTime).format("YYYY-MM-DD") }}</span>
            </div>
            <div class="row">
              提交时间：
              <span>{{ moment(item.updateTime).format("YYYY-MM-DD") }}</span>
            </div>
          </div>
          <div class="no line1">
            俱乐部：<span>{{ item.groupClubName }}</span>
          </div>
          <div class="no line1">
            线路：<span>{{ item.activity_name }}</span>
          </div>
          <div class="no line1">
            证件：<span>{{ item.idCard }}</span>
          </div>
        </div>
        <div class="btns">
          <!-- <div class="btn" style="color: #49ca57;" @click="edit(item)">编辑</div> -->
          <div class="btn" style="color: red" @click="del(item)">取消客单</div>
        </div>
      </div>
      <van-empty v-if="noData" description="暂无数据！" />
    </div>

    <div class="rignt-btn" @click="add()">
      <svg
        t="1627550727004"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1995"
        width="0.6rem"
        height="0.6rem"
      >
        <path
          d="M880.15737 447.719128H575.934072V143.49583c0-35.915501-29.109546-65.025048-65.025048-65.025048s-65.025048 29.109546-65.025047 65.025048v304.223298H141.660679a65.025048 65.025048 0 0 0 0 130.050095h304.223298v304.223298c0 35.915501 29.109546 65.025048 65.025047 65.025048s65.025048-29.109546 65.025048-65.025048V577.769223h304.216073a65.025048 65.025048 0 0 0 65.025047-65.025047 65.010598 65.010598 0 0 0-65.017822-65.025048z"
          fill="#ffffff"
          p-id="1996"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import store from "store";
import QRCode from "qrcodejs2";
import { Dialog, Empty } from "vant";
import moment from "moment";
function debounce(fn, delay) {
  let timeout = null; // 创建一个标记用来存放定时器的返回值
  return function (e) {
    // 每当用户输入的时候把前一个 setTimeout clear 掉
    clearTimeout(timeout);
    // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
}
export default {
  name: "BigDataIndex",
  components: {
    Dialog,
    Empty,
  },
  data() {
    return {
      moment: moment,
      params: {
        iid: this.$route.query.iid || "",
        userId: "",
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      },
      data: [],
      noData: false,
      PayStatusOptions: [{
        name: '未支付',
        value: 0
      }, {
        name: '已预订',
        value: 1
      }, {
        name: '已支付全款',
        value: 2
      }, {
        name: '取消订单',
        value: 3
      }, {
        name: '已退款',
        value: 4
      }, {
        name: '申请退款中',
        value: 5
      }, {
        name: '已失效',
        value: -1
      }],
    };
  },
  mounted: function () {
    document.title = "客单列表";
    this.getList();
    this.$nextTick(() => {
      // this.onScrollBottom(() => {
      //   this.getList(true);
      // });
      window.addEventListener("scroll", this.scroll, true);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll, true);
  },
  methods: {
    changeTab(status) {
      this.params.status = status;
      this.params.pageNumber = 1;
      this.getList();
    },
    getStatus(row){
      let status = ''
      this.PayStatusOptions.forEach(el=>{
        if(el.value === row.status){
          status = el.name
        }
      })
      return status
    },
    getStatusDesc(status){
      if(status == 0) {
        return "未审批";
      }else if(status == 1) {
        return "已审批";
      }else if(status == 3) {
        return "已结算";
      }else if(status == 4) {
        return "不通过";
      }
    },
    scroll() {
      // //搜索栏：50  筛选栏：44  底部栏：tabHeight
      // var tabHeight = Math.round(document.documentElement.clientWidth / 640*68 + 8)
      // var visableHeight = (document.body.clientHeight || document.documentElement.clientHeight) - (94+tabHeight)
      // //页面滚动到底部后再上拉10px触发刷新
      // let scrollEl = document.getElementById('listLayout')
      // console.log(scrollEl.scrollTop,scrollEl.scrollHeight-visableHeight)

      // if(scrollEl.scrollTop + 20> scrollEl.scrollHeight-visableHeight) {
      //   this.getListData()
      // }
      let scroll = document.getElementById("listContentLayout");
      // let _self = this
      // scroll.onscroll = function(){
      // console.log(this.newMessageFlag)
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = scroll.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = scroll.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = scroll.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        // this.params.pageNumber++
        debounce(this.getList(true), 100);

        //到了这个就可以进行业务逻辑加载后台数据了
        // console.log("到了底部");
        // _self.newMessageFlag = false
      }
    },
    add() {
      this.$router.push({
        name: "SalerIndexCustomerInsetEdit",
        query: {
          iid: this.$route.query.iid,
        },
      });
    },
    edit(row) {
      this.$router.push({
        name: "SalerIndexCustomerInsetEdit",
        query: {
          iid: row.iid,
          id: row.id,
        },
      });
    },
    del(row) {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要取消该客单吗？",
      })
        .then(() => {
          appService
            .delCustomerInset({
              id: row.id,
              userId: store.get("loginData").rid || "",
              iid: this.$route.query.iid,
              status: -1,
            })
            .then(
              (data) => {
                if (data.code) {
                  this.$dialog.toast({
                    mes: data.msg,
                    timeout: 1500,
                    icon: "error",
                  });
                  return;
                }
                this.$toast("设置失效成功！");
                this.params.pageNumber = 1;
                this.getList();
              },
              (error) => {
                this.$dialog.toast({
                  mes: error.msg,
                  timeout: 1500,
                  icon: "error",
                });
              }
            );
        })
        .catch(() => {
          // on cancel
        });
    },
    getList(flag) {
      //自己的
      if (flag) this.params.pageNumber++;
      this.params.userId = store.get("loginData").rid || "";
      appService.getCustomerInset(this.params).then(
        (data) => {
          console.log("data", data);
          this.noData = false;
          if (this.params.pageNumber == 1) {
            this.data = [];
            if (!data.content.length) {
              this.noData = true;
            }
          }
          this.data = [...this.data, ...data.content];
        },
        (error) => {
          this.$dialog.toast({
            mes: error.msg,
            timeout: 1500,
            icon: "error",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.page {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  padding: 0.36rem;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  // overflow-y: auto;
  // min-height: 100vh;
  .tabs {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    .item {
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 0.4rem;
      margin-right: 0.5rem;
      width: 1rem;
      &.active {
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.44rem;
        position: relative;
        &:before {
          content: "";
          position: absolute;
          z-index: 1;
          width: 0.38rem;
          height: 0.04rem;
          background: #49ca57;
          box-sizing: border-box;
          bottom: -0.04rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .listContentLayout {
    flex: 1;
    overflow-y: auto;
    .item {
      border-bottom: 0.02rem solid #f1f1f1;
      margin-top: 0.4rem;
      position: relative;
      .line {
        .no {
          font-weight: 400;
          color: #666666;
          line-height: 0.4rem;
          margin-bottom: 0.2rem;
          &.line1 {
            span {
              color: #333333;
            }
          }
          &.line2 {
            display: flex;
            justify-content: space-between;
            .row {
              span {
                color: #333333;
              }
            }
          }
        }
      }
      .btns {
        position: absolute;
        right: 0;
        top: 0;
        font-weight: 400;
        line-height: 0.4rem;
        display: flex;
        .btn {
          margin-left: 15px;
        }
      }
    }
  }
  .rignt-btn {
    position: fixed;
    right: 0.32rem;
    bottom: 1rem;
    width: 1rem;
    height: 1rem;
    background: #26d3a1;
    box-shadow: 0rem 0.04rem 0.14rem 0rem rgba(37, 188, 146, 0.4);
    color: #fff;
    font-size: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    border-radius: 50%;
  }
}
</style>
